import { render, staticRenderFns } from "./MessagesCards.vue?vue&type=template&id=6f437efe&scoped=true"
import script from "./MessagesCards.vue?vue&type=script&lang=js"
export * from "./MessagesCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f437efe",
  null
  
)

export default component.exports